import Actor from './Actor.js'

export default class Jib extends Actor {
	constructor(imageData) {
		super(imageData)
		this.isDucking = false
		this.legFrames = 0
		this.legShowing = 'Left'
		this.sprite = `jib${this.legShowing}Leg`
		this.vVelocity = null
		this.baseY = 0
		this.relativeY = 0
		this.invincible = false
		// these are dynamically set by the game
		this.legsRate = null
		this.lift = null
		this.gravity = null
		this.dead = false
	}

	get y() {
		return this.baseY - this.height + this.relativeY
	}

	set y(value) {
		this.baseY = value
	}

	reset() {
		this.isDucking = false
		this.legFrames = 0
		this.legShowing = 'Left'
		this.sprite = `jib${this.legShowing}Leg`
		this.vVelocity = null
		this.relativeY = 0
		this.dead = false
	}

	jump() {
		if (this.relativeY === 0) {
			this.vVelocity = -this.lift
			return true
		}
		return false
	}

	duck(value) {
		this.isDucking = Boolean(value)
	}

	kill() {
		this.dead = true
	}

	nextFrame() {
		if (this.vVelocity !== null) {
			// use gravity to gradually decrease vVelocity
			this.vVelocity += this.isDucking ? this.gravity * 3 : this.gravity
			this.relativeY += this.vVelocity
		}

		// stop falling once back down to the ground
		if (this.relativeY > 0) {
			this.vVelocity = null
			this.relativeY = 0
		}

		this.determineSprite()
	}

	determineSprite() {
		if (this.dead) {
			this.sprite = 'jibDead'
		} else if (this.relativeY < 0) {
			this.sprite = 'jibJump'
		} else {
			if (this.legFrames >= this.legsRate) {
				this.legShowing = this.legShowing === 'Left' ? 'Right' : 'Left'
				this.legFrames = 0
			}

			if (this.isDucking) {
				this.sprite = `jibDuck${this.legShowing}Leg`
			} else {
				this.sprite = `jib${this.legShowing}Leg`
			}

			this.legFrames++
		}
	}
}
